import React from "react";
import { Row, Col, Container } from "react-bootstrap";
import Styles from "./LegalSegment.module.css";
import RaisedBox from "../../general/RaisedBox";

function LegalSegment(props) {
  return (
    <Container style={{ height: "100%" }}>
      <div className={Styles.EntireLegalSegment}>
        <Row>
          <Col xl={8}>
            {" "}
            <p id={props.id} className={Styles.SegmentHeading}>{props.label}</p>
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            {" "}
            <RaisedBox>
              <p>{props.time}</p>
            </RaisedBox>
          </Col>
        </Row>
        <Row className={Styles.LegalBody}>{props.children}</Row>
      </div>
    </Container>
  );
}

export default LegalSegment;
